import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '@material-ui/icons/Check';
import StepConnector from '@material-ui/core/StepConnector';

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#001540',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#001540',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 6,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#001540',
  },
  circle: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#001540',
    zIndex: 1,
    fontSize: 24,
  },
});

//.WithStyles\(ForwardRef\(StepConnector\)\)-line-109

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));


export default function ActiveStepper(props) {
  const classes = useStyles();
  //const [activeStep, setActiveStep] = React.useState(1);
  const steps = ['Basic Information', 'Background', 'Set Pricing', 'Set Availability', 'Payment Details'];
  const clickStep = () => {
    //console.log('fsdfsdfds')
  }
  const activeStep = (localStorage.getItem('activeStep') ? localStorage.getItem('activeStep') : 0);
  //console.log('props', activeStep)

  return (
    <div className="step-wizard">
      <div className={classes.root}>
        <Stepper  alternativeLabel activeStep={parseInt(activeStep)} connector={<QontoConnector />}>
          {steps.map((label) => (
            <Step key={label} onClick={() => clickStep(activeStep)}>
              <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
    </div>
  );
}